<app-page [inTutorial]="true">
  <wallet [inTutorial]="true"></wallet>
</app-page>
